/**
 * 产品卡片参数滑块拖动功能
 * Product Card Parameters Slider - Drag to Scroll
 */

(function() {
  'use strict';

  class ProductCardSlider {
    constructor(element) {
      this.slider = element;
      this.isDown = false;
      this.startX = 0;
      this.scrollLeft = 0;
      this.velocity = 0;
      this.lastX = 0;
      this.lastTime = 0;
      this.animationFrame = null;

      this.init();
    }

    init() {
      // 鼠标事件
      this.slider.addEventListener('mousedown', this.onMouseDown.bind(this));
      this.slider.addEventListener('mouseleave', this.onMouseLeave.bind(this));
      this.slider.addEventListener('mouseup', this.onMouseUp.bind(this));
      this.slider.addEventListener('mousemove', this.onMouseMove.bind(this));

      // 防止拖拽图片
      this.slider.addEventListener('dragstart', (e) => {
        e.preventDefault();
      });

      // 添加抓手光标样式
      this.slider.style.cursor = 'grab';
    }

    onMouseDown(e) {
      this.isDown = true;
      this.slider.style.cursor = 'grabbing';
      this.slider.style.userSelect = 'none';
      
      this.startX = e.pageX - this.slider.offsetLeft;
      this.scrollLeft = this.slider.scrollLeft;
      this.lastX = e.pageX;
      this.lastTime = Date.now();
      this.velocity = 0;

      // 取消惯性滚动动画
      if (this.animationFrame) {
        cancelAnimationFrame(this.animationFrame);
      }
    }

    onMouseLeave() {
      if (this.isDown) {
        this.isDown = false;
        this.slider.style.cursor = 'grab';
        this.slider.style.userSelect = '';
        this.applyMomentum();
      }
    }

    onMouseUp() {
      if (this.isDown) {
        this.isDown = false;
        this.slider.style.cursor = 'grab';
        this.slider.style.userSelect = '';
        this.applyMomentum();
      }
    }

    onMouseMove(e) {
      if (!this.isDown) return;
      
      e.preventDefault();
      
      const x = e.pageX - this.slider.offsetLeft;
      const walk = (x - this.startX) * 1.5; // 滚动速度倍数
      this.slider.scrollLeft = this.scrollLeft - walk;

      // 计算速度用于惯性滚动
      const now = Date.now();
      const timeDelta = now - this.lastTime;
      
      if (timeDelta > 0) {
        this.velocity = (e.pageX - this.lastX) / timeDelta;
      }
      
      this.lastX = e.pageX;
      this.lastTime = now;
    }

    applyMomentum() {
      // 惯性滚动效果
      if (Math.abs(this.velocity) > 0.1) {
        const friction = 0.95;
        const scroll = () => {
          this.velocity *= friction;
          this.slider.scrollLeft -= this.velocity * 16; // 16ms per frame
          
          if (Math.abs(this.velocity) > 0.1) {
            this.animationFrame = requestAnimationFrame(scroll);
          }
        };
        
        this.animationFrame = requestAnimationFrame(scroll);
      }
    }
  }

  // 初始化所有滑块
  function initSliders() {
    const sliders = document.querySelectorAll('.product-card_metafields_parameters_slider');
    sliders.forEach(slider => {
      new ProductCardSlider(slider);
    });
  }

  // DOM 加载完成后初始化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSliders);
  } else {
    initSliders();
  }

  // 监听动态加载的内容（如 AJAX 加载的产品）
  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) { // Element node
            const sliders = node.querySelectorAll ? 
              node.querySelectorAll('.product-card_metafields_parameters_slider') : [];
            
            sliders.forEach(slider => {
              new ProductCardSlider(slider);
            });
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

})();

